import React from 'react';
import { BLOCKS } from '@contentful/rich-text-types';
import { documentToReactComponents } from '@contentful/rich-text-react-renderer';
import { Box } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import clsx from 'clsx';

const useStyles = makeStyles((theme) => ({
  root: {
    '& > *:first-child': {
      marginTop: 0,
    },
    '& > *:last-child': {
      marginBottom: 0,
    },
  },
  paragraph: {
    margin: ({ spacing }) => theme.spacing(spacing, 0),
  },
}));

const RENDERER_OPTIONS = ({
  classNames,
  overrides: { renderMark, renderNode, renderText },
}) => ({
  renderMark,
  renderNode: {
    [BLOCKS.PARAGRAPH]: (node, children) => {
      // Replace empty <p> nodes with <br />
      if (
        node.content.length === 1 &&
        node.content[0].nodeType === 'text' &&
        node.content[0].value === ''
      ) {
        return <br data-testid="line-break" />;
      } else {
        return <p className={classNames}>{children}</p>;
      }
    },
    ...renderNode,
  },
  renderText:
    renderText ||
    ((text) => {
      // Replace newlines inside <p> nodes with <br />
      return text.split('\n').reduce((children, textSegment, index) => {
        return [
          ...children,
          index > 0 && <br key={index} data-testid="line-break" />,
          textSegment,
        ];
      }, []);
    }),
});

/*
  RichTextContent is a wrapper around a material-ui Box component that can be
  used to render a Contentful Rich Text field. It applies default spacing to any
  child <p> elements, which can be overridden by passing `spacing` prop.
*/
const RichTextContent = (props) => {
  const {
    content,
    rendererOptions = {},
    spacing = 1,
    className,
    ...boxProps
  } = props;

  const classes = useStyles({ spacing });

  const options = RENDERER_OPTIONS({
    classNames: clsx(className, classes.paragraph),
    overrides: rendererOptions,
  });

  return (
    <Box className={classes.root} {...boxProps}>
      {documentToReactComponents(content, options)}
    </Box>
  );
};

export default RichTextContent;
